// Values match the backend ReportingLineIssueType enum names. A const object rather
// than an enum because tsconfig enables erasableSyntaxOnly.
export const ReportingLineIssueType = {
  NoManager: "NoManager",
  InactiveManager: "InactiveManager",
  SelfReporting: "SelfReporting",
  CrossBuManager: "CrossBuManager",
} as const

export type ReportingLineIssueType =
  (typeof ReportingLineIssueType)[keyof typeof ReportingLineIssueType]

export const REPORTING_LINE_ISSUE_LABELS: Record<ReportingLineIssueType, string> = {
  [ReportingLineIssueType.NoManager]: "No manager",
  [ReportingLineIssueType.InactiveManager]: "Inactive manager",
  [ReportingLineIssueType.SelfReporting]: "Reports to self",
  [ReportingLineIssueType.CrossBuManager]: "Manager in another BU",
}
